<template>
  <v-dialog v-model="dialog"
            width="500">
    <template v-slot:activator="{ on }">
      <v-btn color="primary"
             v-on="on"
             class="mb-6"
             block>
        {{mission.module.label}}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline primary white--text"
                    primary-title>
        {{mission.module.label}} - {{parcours.ado ? "12 ans et plus" : "Moins de 12 ans"}}
      </v-card-title>

      <v-card-text class="pt-5">
        <v-checkbox v-model="parcours.retour" label="De retour à la maison" />
        <v-checkbox v-model="parcours.douleur" label="Gérer la douleur à la maison" />
        <v-checkbox v-model="parcours.fievre" label="Gérer la fièvre à la maison" v-show="!parcours.ado" />
        <v-checkbox v-model="parcours.init_hydro" label="Initiation de l'Hydroxyurée" v-show="!parcours.ado" />
        <v-checkbox v-model="parcours.rate" label="Je surveille la rate de mon enfant" v-show="!parcours.ado" />
        <v-checkbox v-model="parcours.echanges" label="On débute les échanges transfusionnels" />
        <v-checkbox v-model="parcours.medicaments" label="J'ai du mal avec mes médicaments" v-show="parcours.ado" />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text
               @click="dialog = false">Annuler
        </v-btn>
        <v-btn color="primary"
               text
               :loading="loading"
               @click="submit">
          Valider
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from 'api'
import moment from "moment";
import IriadeDoctorSelect from 'components/Screens/Doctor/CreatePatient/components/IriadeDoctorSelect'

export default {
  components: {
    IriadeDoctorSelect
  },

  data () {
    return {
      dialog: false,
      loading: false,
      doctor_id: null,

      parcours: {
        ado: false,
        retour : 0,
        douleur : 0,
        fievre : 0,
        init_hydro : 0,
        rate : 0,
        echanges : 0,
        medicaments : 0,
      }
    }
  },

  methods: {
    submit () {
      this.loading = true
      api.post(`applidrep/prescrire/${this.mission.patient_id}`, {
        P2: (this.parcours.ado ? 0 : this.parcours.retour),
        P3: (this.parcours.ado ? 0 : this.parcours.douleur),
        P4: (this.parcours.ado ? 0 : this.parcours.fievre),
        P5: (this.parcours.ado ? 0 : this.parcours.init_hydro),
        P6: this.parcours.rate,
        P7: (this.parcours.ado ? 0 : this.parcours.echanges),
        P8: (this.parcours.ado ? this.parcours.retour : 0),
        P9: (this.parcours.ado ? this.parcours.douleur : 0),
        P10: this.parcours.medicaments,
        P11: (this.parcours.ado ? this.parcours.echanges : 0),
      })
        .then(res => {
          this.dialog = false
          this.loading = false
          this.$mango.snackbar({
            color: 'success',
            text: "Les parcours ont été préscrits."
          })
          //document.location.reload();
        })
        .catch(err => console.log(err))
    }
  },

  mounted() {
    this.parcours.ado = moment().diff(this.mission.patient.birthdate, "years") >= 12;
  },

  props: {
    mission: {
      required: true,
      type: Object
    }
  }
}
</script>
